import Vue from 'vue'
import Router from 'vue-router'
import LoginPage from '../components/Modules/Authentication/LoginPage.vue'
import UnAuthorizedPage from '../components/Modules/Shared/UnAuthorized.vue'
import TestAuthPage from '../components/Modules/Authentication/TestAuthPage.vue'
//import Auth from '@okta/okta-vue'
//import oktaConfig from '../config/Okta.config'

Vue.use(Router)
//Vue.use(Auth, oktaConfig.oidc)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/login/callback',
            component: () => import('../components/Modules/Authentication/Callback.vue'),
        },
        {
            path: '/Auth/Index',
            component: LoginPage
        },
        {
            path: '/',
            name: 'Home',
            component: () => import('../components/Modules/Home/Home.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/UserManagement',
            name: 'User Management',
            component: () => import('../components/Modules/UserManagement/UserManagement.vue'),
            meta: {
                requiresAuth: true,
                requiresAdmin: true
            }
        },
        {
            path: '/QHP',
            name: 'QHP',
            component: () => import('../components/Modules/QHP/SurveyAnalytics/QHP.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
          path: '/Commercial',
          name: 'Commercial',
            component: () => import('../components/Modules/Commercial/SurveyAnalytics/Commercial.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/Medicaid',
            name: 'Medicaid',
            component: () => import('../components/Modules/Medicaid/SurveyAnalytics/Medicaid.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/Medicare',
            name: 'Medicare',
            component: () => import('../components/Modules/Medicare/SurveyAnalytics/Medicare.vue'),
            children: [
                {
                    path: '/Medicare/YourData',
                    name: 'YourData',
                    component: () => import('../components/Modules/Shared/YourData/YourData.vue'),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: '/Medicare/Benchmark',
                    name: 'Benchmark',
                    component: () => import('../components/Modules/Shared/Benchmark/Benchmark.vue'),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: '/Medicare/Segment',
                    name: 'Segment',
                    component: () => import('../components/Modules/Shared/Segment/Segment.vue'),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: '/Medicare/Cohort',
                    name: 'Cohort',
                    component: () => import('../components/Modules/Shared/Cohort/Cohort.vue'),
                    meta: {
                        requiresAuth: true
                    }
                }
            ]
        },
        {
            path: '/UnAuthorized',
            name: 'UnAuthorized',
            component: UnAuthorizedPage
        },
        {
            path: '/Auth/TestAuthPage',
            name: 'TestAuthPage',
            component: TestAuthPage
        },
        // otherwise redirect to home
        {
            path: '*',
            redirect: '/'
        }
    ]
});



// router.beforeEach(Vue.prototype.$auth.authRedirectGuard());

//router.beforeEach(
//    (to, from, next) => {

//        if (to.meta.requiresAuth) {

//           // next();
//        }

//        if (to.meta.requiresAdmin) {
//            var idTokenclaims = JSON.parse(localStorage.getItem('okta-token-storage'));
//            var internalAdmin = idTokenclaims.idToken.claims.GroupsClaim.filter(role => role.toLowerCase() == "sph internal admin");
//            console.log(internalAdmin);
//            if (internalAdmin.length > 0) {
//                next();
//            }
//            else {
//                return next('/UnAuthorized');
//            }
//        }             
//    }
//);

/*router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/Auth/Index', '/UnAuthorized'];
    const authRequired = !publicPages.includes(to.path);
    let user = (store.getters['Authentication/getUserToken']);
    
    if (authRequired)
    {
       
        if (!user) {
          
            var TabName
            if (to.name != 'YourData' && user == null) {  

                TabName = 'YourData';
            }
            else {
                TabName = to.name;
            }
          
            let accessToken = store.getters['Authentication/getAccessTokenFromCookie'];
            if (!accessToken)
            {
                router.push({ name: 'UnAuthorized' });     
            }
            let applicationId = `${process.env.VUE_APP_PORTAL_ID}`;
            if (accessToken && applicationId) {
               
                store.dispatch('Authentication/login', { accessToken, applicationId, TabName});
     
                
            }
            //user = store.getters['Authentication/getUserToken'];
            //if (!(user && user.token))
            //    return next('/UnAuthorized');
        }
        else
            next();
    }
    else
    next();
})
*/

export default router;